import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import {withMemo} from 'helpers/wrapper';
import {useEffectEvent} from 'helpers/hooks/utils';

const Debounce = withMemo((props) => {
  const {
    frames,
    timeout,
    placeholder,
    condition,
    children,
    onLoaded,
  } = {
    frames: 0,
    timeout: 0,
    condition: true,
    ...props
  };

  const [loaded, setLoaded] = useState(false);

  const onLoadedEvent = useEffectEvent(onLoaded);
  useEffect(() => {
    if (timeout && !loaded) {
      return utils.observeTimeout(() => {
        setLoaded(true);
      }, timeout);
    }
  }, [timeout, loaded]);

  useEffect(() => {
    if (frames && !loaded) {
      let rafId, remaining = frames;

      const tick = () => {
        remaining -= 1;
        if (remaining === 0) {
          setLoaded(true);
        } else {
          rafId = requestAnimationFrame(tick);
        }
      };

      rafId = requestAnimationFrame(tick);

      return () => cancelAnimationFrame(rafId);
    }
  }, [frames, loaded]);

  useEffect(() => {
    if (condition && (!(timeout || frames) || loaded)) {
      onLoadedEvent?.();
    }
  }, [timeout, frames, loaded, condition, onLoadedEvent]);

  if (condition && (!(timeout || frames) || loaded)) {
    return children;
  } else if (placeholder) {
    return placeholder;
  }
})

Debounce.propTypes = {
  placeholder: PropTypes.any,
  frames: PropTypes.number,
  timeout: PropTypes.number,
  condition: PropTypes.bool
};

export default Debounce;
